export const ncFileStatuses = {
  PartiallyLinked: 'PartiallyLinked',
  Linked: 'Linked',
  Unknown: 'Unknown',
  Unlinked: 'Unlinked',
  Undefined: 'Undefined',
  Ignored: 'Ignored',
  Change: 'Change',
  Setup: 'Setup',
};

export const loadNCFileStatus = {
  READY: 'ready',
  LOADING: 'loading',
  ERROR: 'error',
  BLOB_ERROR: 'blob_error',
  NO_HASH: 'no_hash',
  NO_STATUS: 'no_status',
  STATUS_ERROR: 'status_error',
  DOWNLOADING: 'downloading',
};
